import { render, staticRenderFns } from "./TransferFeeTable.vue?vue&type=template&id=378a7712&"
import script from "./TransferFeeTable.vue?vue&type=script&lang=js&"
export * from "./TransferFeeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports